import { createSelector } from '@ngrx/store';
import { companyFeature } from './company.reducer';

export const {
  selectCompanies,
  selectTotalCount,
  selectCurrentPage,
  selectLimit,
  selectSearch,
  selectIsLoading,
  selectMode,
  selectSelectedCompany,
  selectIsLoadingDetail,
  selectIsSaving,
  selectIsDeleting,
  selectCurrencies,
  selectOperatorUsers,
  selectPageCache,
  selectSupplierSettings,
  selectIsLoadingSupplierSettings,
  selectIsSavingSupplierSettings,
  selectBuyerConfigSettings,
  selectIsLoadingBuyerConfigSettings,
  selectIsSavingBuyerConfigSettings,
  selectIsResettingBuyerConfigSettings,
  selectSegmentation,
  selectIsLoadingSegmentation,
  selectIsSavingSegmentation,
  selectIsTogglingSegmentation,
  selectError,
  selectIsRegisteringWebhook,
  selectIsUnsubscribingWebhook,
} = companyFeature;

export const selectLoadContext = createSelector(
  selectCurrentPage,
  selectSearch,
  selectLimit,
  selectPageCache,
  (currentPage, search, limit, pageCache) => ({
    currentPage,
    search,
    limit,
    pageCache,
  }),
);
